<template>
  <div>
    <el-form ref="form" :model="appVersionForm" label-width="80px" :rules="rules">
      <!-- <el-form-item label="版本别名" prop="versionAlias">
        <el-input v-model="appVersionForm.versionAlias" style="width: 200px;"
          :disabled="Object.keys(editVersion).length > 0"></el-input>
      </el-form-item> -->
      <el-form-item label="应用版本" prop="version">
        <el-input
v-model="appVersionForm.version"
style="width: 200px;"
          :disabled="Object.keys(editVersion).length > 0"></el-input>
      </el-form-item>
      <el-form-item label="架构" prop="arch">
        <el-checkbox-group v-model="appVersionForm.arch">
          <el-checkbox v-for="arch in checkedArchArr" :label="arch" :key="arch">{{ arch }}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="版本描述" prop="description">
        <textarea
v-model="appVersionForm.description"
          style="width: 400px;padding: 10px;border: 1px solid #e3e3e3;border-radius: 6px;"></textarea>
      </el-form-item>
      <el-form-item label="上传文件" v-if="Object.keys(editVersion).length == 0">
        <el-upload
class="upload"
ref="upload"
action="string"
:file-list="fileList"
:auto-upload="false"
          :http-request="uploadFile"
:on-change="handleChange"
:on-preview="handlePreview"
:on-remove="handleRemove"
          :multiple="true">
          <div class="uploadBox">
            <i class="el-icon-plus"></i>
            <p>上传</p>
          </div>
          <div slot="tip" class="el-upload__tip">请上传软件包</div>
        </el-upload>
      </el-form-item>
      <el-form-item prop="detail" label="版本详情">
        <MdEditor :content.sync="appVersionForm.detail"></MdEditor>
      </el-form-item>
      <el-form-item>
        <el-button class="save_btn" type="primary" @click="submit" :loading="Loading">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { errorHandle } from '../../../../utils/error';
import { uploadBinaryFileInfo, uploadBinaryFilePath } from '@/api/app';
export default {
  name: 'AppSoftwareCreate',
  components: {},
  props: {
    marketID: String,
    dialogVisible: Boolean,
    onClose: Function,
    onSuccess: Function,
    appType: String,
    appID: String,
    editVersion: Object,
    editFun: Function
  },
  data() {
    var baseDomain = process.env.BASE_API;
    if (baseDomain == '/') {
      baseDomain = window.location.origin;
    }
    return {
      mode: 'default',
      checkedArch: [],
      checkedArchArr: ['arm64', 'amd64'],
      centerDialogVisible: false,
      Loading: false,
      fileList: [],
      isFlag: true,
      fileFormData: [],
      appVersionForm: {
        version: '',
        versionAlias: '',
        description: '',
        arch: [],
        detail: ''
      },
      editor: null,
      toolbarConfig: {
        excludeKeys: ['uploadVideo', 'fullScreen', 'emotion']
      },
      editorConfig: {
        placeholder: '请输入内容...',
        MENU_CONF: {
          uploadImage: {
            customUpload: this.uploadImg
          }
        }
      },
      rules: {
        version: [
          { required: true, message: '请输入应用版本', trigger: 'blur' }
        ],
        versionAlias: [
          { required: true, message: '请输入应用版本别名', trigger: 'blur' }
        ],
        description: [
          { required: false, message: '请输入应用版本描述', trigger: 'blur' }
        ],
        detail: [
          { required: true, message: '请输入版本详情', trigger: 'blur' }
        ]
      }
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo
    }),
    myorgs() {
      return this.$store.state.user.userOrgs;
    }
  },
  created() {
    if (Object.keys(this.editVersion).length > 0) {
      this.appVersionForm = this.editVersion;
    }
  },
  mounted() { },
  methods: {
    uploadImg(file, insertFn) {
      const imgData = new FormData();
      imgData.append('file', file);
      axios({
        url: this.uploadConfig.api,
        method: 'post',
        data: imgData
      }).then((response) => {
        insertFn(response.data.FileURL);
      });
    },
    onCreated(editor) {
      this.editor = Object.seal(editor);
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.Loading = true;
          const params = {
            marketID: this.marketID,
            appID: this.appID,
            file: this.fileFormData
          };
          if (Object.keys(this.editVersion).length > 0) {
            const obj = {
              marketID: this.marketID,
              appID: this.appID,
              version: this.appVersionForm.version,
              versionAlias: '',
              description: this.appVersionForm.description,
              arch: this.appVersionForm.arch && this.appVersionForm.arch.length > 0 ? this.appVersionForm.arch.join(',') : '',
              detail: this.appVersionForm.detail,
              is_plugin: this.appVersionForm.is_plugin,
              templateType: this.appVersionForm.templateType,
              enable: this.appVersionForm.enable
            };
            this.editFun(obj)
          } else {
            uploadBinaryFilePath(params)
              .then((res) => {
                this.Loading = false;
                this.$message({
                  message: '上传成功',
                  type: 'success'
                });

                this.$refs.form.validate((valid) => {
                  if (valid) {
                    const obj = {
                      path: res.bean.FileURL,
                      marketID: this.marketID,
                      appID: this.appID,
                      version: this.appVersionForm.version,
                      versionAlias: this.appVersionForm.versionAlias,
                      description: this.appVersionForm.description,
                      arch: this.appVersionForm.arch && this.appVersionForm.arch.length > 0 ? this.appVersionForm.arch.join(',') : '',
                      detail: this.appVersionForm.detail
                    };
                    uploadBinaryFileInfo(obj)
                      .then((res) => {
                        this.Loading = false;
                        this.$message({
                          message: '创建版本成功',
                          type: 'success'
                        });
                        this.onSuccess()
                      })
                      .catch((err) => {
                        this.Loading = false;
                        this.$message({
                          message: '创建版本失败',
                          type: 'error'
                        });
                      });
                  }
                });
              })
              .catch((err) => {
                this.Loading = false;
                this.$message({
                  message: '上传失败',
                  type: 'error'
                });
              });
          }
        }
      });
    },
    close() {
      this.onClose && this.onClose();
    },
    // 自定义上传文件
    uploadFile(file) {

    },
    handleChange(file, fileList) {
      this.fileList = [];
      this.fileFormData = [];
      this.fileList = fileList;
      const formData = new FormData();
      this.fileList.forEach((file) => {
        formData.append('file', file.raw); // 拿到存在fileList的文件存放到formData中
      });
      this.fileFormData = formData;
    },
    // 点击文件
    handlePreview(file) {

    },
    // 删除文件
    handleRemove(file, fileList) {
      this.fileList = [];
      this.fileFormData = [];
      this.fileList = fileList;
      const formData = new FormData();
      this.fileList.forEach((file) => {
        formData.append('file', file.raw); // 拿到存在fileList的文件存放到formData中
      });
      this.fileFormData = formData;
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.inputdesc {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
  transition: color 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);
}

.uploadHelm {
  width: 100%;
  height: 80px;
  display: flex;
  align-items: center;
  border: 1px solid #e3e3e3;
  border-radius: 5px;

  .iconUpload {
    width: 90px;
  }

  .fileUpload {
    // width: calc(100% - 90px);
    // margin-left: 12px;
  }
}
.dialog {
}
::v-deep .el-dialog__body {
  min-height: 300px;
}
::v-deep .el-upload {
  color: #415d94;
  font-weight: 600;
  border: 2px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  text-align: center;
  padding: 20px;
  background-color: #fafafa;
  transition: border-color 0.3s;

  &:hover {
    border-color: #409eff;
  }

  p {
    margin: 8px 0;
    font-size: 14px;
    line-height: 1.5;
  }

  img {
    width: 40px;
    height: 40px;
    margin-bottom: 10px;
  }
}
::v-deep .el-upload__tip {
  color: #8d8d8d;
}
// ::v-deep .el-upload-list{
//     display: none;
// }
.helmInfo {
  width: 100%;
  padding: 12px;
  min-height: 300px;

  h3 {
    font-weight: 550;
  }

  p {
    margin-top: 16px;
    display: flex;

    span {
      display: block;
    }

    span:last-child {
      width: calc(100% - 124px);
      font-weight: 550;
      margin-left: 12px;
    }

    span:first-child {
      width: 100px;
      text-align: right;
    }
  }

  // background-color: cornflowerblue;
}

.uploadBox {
  width: 100px;
  height: 80px;
  border: 1px solid #dcdfe6;
  border-radius: 5px;

  p {
    margin-top: -12px;
    color: #606266;
    font-weight: 400;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/storeManage/appManage/components/appSoftwareCreate.vue